(function() {
	// globals
	window.EWO.Election = window.EWO.Election || {};

	// module functions
	//candidates has a default filter, that defaults to the first returned list.
	//so if there is no selected list, on load, we get the list, select the first returned
	//item, and redirect to that
	page('/election/:electionId/constituency/:constituencyId/candidates', function(ctx, next) {
		var urlQueryString = new URLSearchParams(ctx.querystring);
		
		if (urlQueryString.has('listId')) {
			next();
			return;
		}
		$.get(EWO.config.apiUrlPrefix + '/lists?constituencyid=' + ctx.params.constituencyId)
		.done(function(lists) {
			if (lists.rows.length > 0) {
				var firstListId = lists.rows[0].id;
				page(document.location.pathname + '?listId=' + firstListId);
			} else {
				PNotify.error(i18next.t('No lists found for this constituency'));
			}
		});
	});
	EWO.MD({
		global: EWO.Election,
		name: 'electionCandidates',
		containerClass: 'js-electionCandidates',
		attachToElement: '.js-election-container',
		listTemplate: '/app/election/candidates/templates/candidates.ejs',
		createOrEditTemplate: '/app/election/candidates/templates/candidatesCreateOrEdit.ejs',
		createOrEditValidationRules: {
			rules: {
				num: {
					required: true,
					number: true
				},
				firstname: 'required',
				familyname: 'required',
				sex: 'required',
				runfor: 'required',
				languagegroup: 'required',
				birthplaceselector: {
					required: true
				},
				birthMunicipalityId: {
					required: function(element) {
						return $('#birthplaceselector').val() === '1';
					}
				},
				birthPlace: {
					required: function(element) {
						return $('#birthplaceselector').val() === '2';
					}
				},
				birthday: {required: true}
			}
		},
		listAdditionalData: function(filter) {
			return $.get(EWO.config.apiUrlPrefix + '/lists?constituencyid=' + filter.constituencyId);
		},
		// listCallback: function() {
		// 	$('#listId').select2({'allowClear': false});

		// 	var urlParams = new URLSearchParams(window.location.search);
		// 	if(urlParams.has('scrollTo')) {
		// 		const $scroll = $("#" + urlParams.get('scrollTo'));
		// 		if ($scroll.length) {
		// 			$('html,body').animate({
		// 				scrollTop: $scroll.offset().top
		// 			}, 'fast');
		// 		}
		// 	}
		// },
		createOrEditAdditionalData: function(id, filter, qs, detail) {
			delete filter.id;
			var d = $.Deferred();
			$.when(
				$.get(EWO.config.apiUrlPrefix + '/types/genders'),
				$.get(EWO.config.apiUrlPrefix + '/candidates/types?constituencyid=' + filter.constituencyId + '&onlyMayor=false'),
				$.get(EWO.config.apiUrlPrefix + '/types/languagegroups'),
				$.get(EWO.config.apiUrlPrefix + '/lists/' + qs.listId),
				$.get(EWO.config.apiUrlPrefix + '/types/allprovinces'),
				$.get(EWO.config.apiUrlPrefix + '/types/nations'),
				$.get(EWO.config.apiUrlPrefix + '/types/municipalitybyprovince?provId=' + (detail ? (detail.birthProvinceId != undefined ? detail.birthProvinceId : '-1') : '-1'))
			)
			.done(function(genders, types, groups, currentList, provinces, nations, municipalities) {
				d.resolve({
					genders: genders[0].rows,
					types: types[0].rows,
					groups: groups[0].rows,
					currentList: currentList[0],
					provinces: provinces[0].rows,
					nations: nations[0].rows,
					municipalities: detail.birthProvinceId ? municipalities[0].rows : {}
				});
			})
			.fail(function() {
				d.reject();
			});

			window.scrollTo(0,0);

			return d;
		},
		createOrEditCallback: function() {
			$('#birthday').datepicker({endDate: '+0d' });
			$('#birthNationId').select2();
			$('#birthProvinceId').select2();
			$('#birthMunicipalityId').select2();

			if ($('#birthProvinceId').val() != undefined && $('#birthProvinceId').val() > 0) {
				$('#birthNationId').parents('.form-group').hide();
				$('#birthProvinceId').parents('.form-group').show();
				$('#birthMunicipalityId').parents('.form-group').show();
				$('#birthPlace').parents('.form-group').hide();
			} else {
				if ($('#birthplaceselector').val() == 1) {
					$('#birthNationId').parents('.form-group').hide();
					$('#birthProvinceId').parents('.form-group').show();
					$('#birthMunicipalityId').parents('.form-group').show();
					$('#birthPlace').parents('.form-group').hide();
				} else {
					$('#birthNationId').parents('.form-group').show();
					$('#birthProvinceId').parents('.form-group').hide();
					$('#birthMunicipalityId').parents('.form-group').hide();
					$('#birthPlace').parents('.form-group').show();
				}
			}
		},
		beforeSaveCallback: function(data) {
			//fix dates
			delete data.birthplaceselector;
			data.birthday = moment(data.birthday, 'L').format('YYYY-MM-DD');
			return data;
		},
		datatablesOptions: {
			pageLength: 50
		},
		apiRoot: EWO.config.apiUrlPrefix + '/candidates',
		routingRoot: '/election/:electionId/constituency/:constituencyId/candidates'
	});

	// events
	$(document).on('change', '.js-electionCandidates #birthplaceselector', function(ev) {
		var el = $(ev.currentTarget);
		ev.preventDefault();

		if (el.val() === '1') {
			$('#birthPlace').parents('.form-group').hide();
			$('#birthNationId').parents('.form-group').hide();
			$('#birthNationId').val(1);
			$('#birthProvinceId').parents('.form-group').show();
			$('#birthMunicipalityId').parents('.form-group').show();
			$('#birthPlace').val('');
		} else {
			$('#birthPlace').parents('.form-group').show();
			$('#birthNationId').parents('.form-group').show();
			$('#birthProvinceId').parents('.form-group').hide();
			$('#birthMunicipalityId').parents('.form-group').hide();
			$('#birthNationId').val('').trigger('change');
			$('#birthProvinceId').val('').trigger('change');
			$('#birthMunicipalityId').val('').trigger('change');
		}
	});

	$(document).on('change', '.js-electionCandidates #birthProvinceId', function(ev) {
		var el = $(ev.currentTarget);
		ev.preventDefault();
		if ($(el).val() != undefined && $(el).val() != '') {
			muniOptions($(el).val());
		}
	});

	// $(document).on('click', '.js-electionCandidates .js-back', function(ev) {
	// 	console.log('back');
	// 	var el = $(ev.currentTarget);
	// 	ev.preventDefault();
	// 	var redirectParameters = el.attr('data-redirect-parameters');
	// 	var constituencyId = el.attr('data-constituencyId');
	// 	var electionId = el.attr('data-electionId');

	// 	page.redirect('/election/' + electionId + '/constituency/' + constituencyId + '/candidates?' + redirectParameters);
	// });

	var muniOptions = function(provId) {
		$.ajax({
			url: EWO.config.apiUrlPrefix + '/types/municipalitybyprovince?provId=' + provId,
			method: 'GET',
			handled: true
		})
		.done(function(response) {
			$('#birthMunicipalityId').select2('enable');
			$('#birthMunicipalityId').empty().trigger('change');
			$('#birthMunicipalityId').select2({data: response.rows.map(function(e) {return {id: e.id, text: e.desc};})});
			$('#birthMunicipalityId').prepend('<option selected=""></option>').select2({placeholder: i18next.t('Select a municipality')});
			$('#birthMunicipalityId').trigger('change');
		});
	};



	// module startup

	//setup routing
})();
